import { render } from "./FaqListItem.vue?vue&type=template&id=54d7700b"
import script from "./FaqListItem.vue?vue&type=script&lang=js"
export * from "./FaqListItem.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import RenderMarkdown from "@/components/RenderMarkdown.vue";
import BaseIcon from "@/components/BaseIcon.vue";
import BaseConfirmModal from "@/components/BaseConfirmModal.vue";
script.components = Object.assign({}, { RenderMarkdown, BaseIcon, BaseConfirmModal }, script.components);